import { assign } from "lodash";
import {
  QUERY_RELATIONSHIPS_REQUEST,
  QUERY_RELATIONSHIPS_SUCCESS,
  QUERY_RELATIONSHIPS_FAILURE
} from "../types";

// const sameRequest = (state, payload) =>
//   state.status === payload.status &&
//   state.limit === payload.limit &&
//   state.offset === payload.offset &&
//   state.ordering === payload.ordering;

export default (
  state = {
    members: {
      loading: false,
      ids: []
    }
  },
  action
) => {
  switch (action.type) {
    case QUERY_RELATIONSHIPS_REQUEST:
      return {
        ...state,
        relationships: assign({}, state.relationships, {
          ids: [],
          loading: true
          // status: action.payload.status,
          // limit: action.payload.limit,
          // offset: action.payload.offset,
          // ordering: action.payload.ordering,
          // filters: action.payload.filters
        })
      };
    case QUERY_RELATIONSHIPS_SUCCESS:
      // if (sameRequest(state, action.payload)) {
      return {
        relationships: assign({}, state.relationships, {
          loading: false,
          id: action.payload.id,
          ids: action.payload.items,
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous
        })
      };
    // }
    // return state;
    case QUERY_RELATIONSHIPS_FAILURE:
      return {
        relationships: assign({}, state.relationships, {
          loading: false
        })
      };
    // return state;
    default:
      return state;
  }
};
